export default function GeminiIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "className">,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={props.className}
    >
      <g clipPath="url(#clip0_19918_25366)">
        <path
          d="M23.6654 12.024C20.6381 12.2098 17.7833 13.4961 15.6387 15.6407C13.4942 17.7853 12.2078 20.6401 12.022 23.6673H11.9754C11.7899 20.64 10.5037 17.785 8.35899 15.6404C6.21434 13.4957 3.35936 12.2095 0.332031 12.024L0.332031 11.9773C3.35936 11.7919 6.21434 10.5056 8.35899 8.36095C10.5037 6.21629 11.7899 3.36131 11.9754 0.333984L12.022 0.333984C12.2078 3.36121 13.4942 6.21601 15.6387 8.3606C17.7833 10.5052 20.6381 11.7915 23.6654 11.9773V12.024Z"
          fill="url(#paint0_radial_19918_25366)"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_19918_25366"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(2.64787 9.81753) rotate(18.6832) scale(24.8354 198.947)"
        >
          <stop offset="0.067" stopColor="#9168C0" />
          <stop offset="0.343" stopColor="#5684D1" />
          <stop offset="0.672" stopColor="#1BA1E3" />
        </radialGradient>
        <clipPath id="clip0_19918_25366">
          <rect
            width="23.3333"
            height="23.3333"
            fill="white"
            transform="translate(0.332031 0.333496)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
